import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { MasterLayoutComponent } from './pages/layout-component/master-layout/master-layout.component';

const routes: Routes = [
  //{
  //  // Needed for handling redirect after login
  //  path: '',
  //  component: MsalRedirectComponent,
  //  canActivate: [MsalGuard]
  //},
  //{
  //  path: '',
  //  loadChildren: () =>
  //    import('src/app/outer-components/outer-component.module').then((m) => m.OuterComponentModule),

  //},
  {
    path: '',
    component: MasterLayoutComponent,
    loadChildren: () =>
      import('src/app/pages/pages-routing.module').then((m) => m.PagesRoutingModule),

  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: false 
  })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
